import { Box, Checkbox, Flex, Label, Text } from '@modusign/design-system';
import { ChangeEvent } from 'react';

interface InPersonModalLabeledCheckBoxProps {
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  label: string;
}

export default function InPersonModalLabeledCheckBox({
  checked,
  onChange,
  label,
}: InPersonModalLabeledCheckBoxProps) {
  return (
    <Flex alignItems="flex-start" justifyContent="flex-start" mt={6} width="100%">
      <Box pt={1} width="24px">
        <Checkbox checked={checked} id="block-signers-check" weight="sm" onChange={onChange} />
      </Box>
      <Label
        htmlFor="block-signers-check"
        mb={0}
        ml={2}
        sx={{
          cursor: 'pointer',
        }}
      >
        <Text
          color="textNeutralSlightlyLight"
          fontSize="md"
          fontWeight="medium"
          sx={{ wordBreak: 'normal' }}
        >
          {label}
        </Text>
      </Label>
    </Flex>
  );
}
